import { types } from "../types/types";

export const setCompany = ( id, name, subscription, storage, emailVerified, settings  ) => {
    return {
        type: types.setCompany,
        payload: {
            id,
            name,
            subscription,
            storage,
            adminEmailVerified: emailVerified,
            settings,
        }
    }
}

export const updateEmailVerified = ( verified ) => {
    return {
        type: types.updateEmailVerified,
        payload: {
            adminEmailVerified: verified
        }
    }
}

export const updateCompanyName = (name) => {
    return {
        type: types.updateCompanyName,
        payload: {
            name,
        },
    }
}

export const updateCompanyLogo = (logoUrl) => {
    return {
        type: types.updateCompanyLogo,
        payload: {
            logoUrl,
        },
    }
}

export const updateCompanySettings = (settings = {}) => {
    return {
        type: types.updateCompanySettings,
        payload: {
            settings,
        },
    }
}

export const unsetCompany = () => {
    return {
        type: types.unsetCompany,
    }
}